import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  splitString,
  isFamilyEmoji,
  isFamilyEmojiFour,
} from "./ReportFunctionality/splitString";

const generateMessageConversationPDF = (title, messageConversation) => {
  if (!Array.isArray(messageConversation)) {
    console.error("Invalid data provided to generate PDF. Expected an array.");
    return;
  }

  const pdf = new jsPDF();
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  // Set document properties
  pdf.setProperties({
    title: title || "Message",
  });

  // Define X positions for the columns
  // Header Section
  pdf.setFontSize(14);
  pdf.setFont("helvetica", "bold");
  pdf.text("Message", pageWidth / 2, 10, { align: "center" });
  pdf.setFontSize(12);
  pdf.text(title, pageWidth / 2, 20, { align: "center" });

  // Set font size and color for both labels and values
  pdf.setFontSize(10);
  pdf.setTextColor(255, 144, 29); // Orange color for labels and values

  let currentY = 30; // Starting position for the table
  const recordsPerPage = 5; // Max records per page
  let recordCount = 0;

  messageConversation.forEach((messageConversation) => {
    if (recordCount === recordsPerPage || currentY + 60 > pageHeight - 30) {
      addWatermark(pdf, pageWidth, pageHeight); // Add watermark
      pdf.addPage();
      currentY = 20; // Reset Y position for the new page
      recordCount = 0; // Reset record count
    }

    const tableData = [
      [{ content: "From" }, { content: messageConversation?.From || "N/A" }],
      [{ content: "To" }, { content: messageConversation?.To || "N/A" }],
      [
        { content: "Subject" },
        { content: messageConversation?.Subject || "N/A", styles: { textColor: [255, 255, 255] }, },
      ],
      [{ content: "Body" }, { content: messageConversation?.Body || "N/A", styles: { textColor: [255, 255, 255] }, }],
    ];

    autoTable(pdf, {
      startY: currentY,
      body: tableData,
      theme: "grid",
      styles: {
        fontSize: 10,
        cellPadding: 3,
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
        halign: "left",
      },
      columnStyles: {
        0: { fontStyle: "bold" },
        1: { cellWidth: pageWidth * 0.5 },
      },
    });

    // -------(Emoji Start)----- Message Subject Formation ------------------------------------------------------------------

    document.getElementById("output").innerHTML = splitString(
      messageConversation?.Subject
    );

    const output = document.getElementById("output");
    const elements = output.querySelectorAll(".emoji, .text");

    let xPosition = 94;
    let yPosition = currentY + 27;
    const maxWidth = pdf.internal.pageSize.width - 20;
    const lineHeight = 4;

    elements.forEach((element, index) => {
      if (element.classList.contains("emoji")) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // canvas.width = 30;
        // canvas.height = 30;
        if (isFamilyEmoji(element.innerText)) {
          canvas.width = 40;
          canvas.height = 40;
        } else if (isFamilyEmojiFour(element.innerText)) {
          canvas.width = 40;
          canvas.height = 40;
        } else {
          canvas.width = 35;
          canvas.height = 35;
        }
        ctx.font = "13px  Calibri, sans-serif";
        ctx.fillText(element.innerText, 0, 18);

        const imgData = canvas.toDataURL("image/png");

        if (xPosition + 6 > maxWidth) {
          xPosition = 47;
          yPosition += lineHeight;
        }
        xPosition = xPosition - 1;
        if (isFamilyEmojiFour(element.innerText))
          pdf.addImage(imgData, "PNG", xPosition + 1, yPosition - 5, 8, 10);
        else if (isFamilyEmoji(element.innerText))
          pdf.addImage(imgData, "PNG", xPosition + 1, yPosition - 5, 10, 10);
        else pdf.addImage(imgData, "PNG", xPosition + 1, yPosition - 5, 10, 10);
        // pdf.addImage(imgData, 'PNG', xPosition, yPosition - 5, 8, 8);
        xPosition += 6;
      } else {
        pdf.setFont("helvetica", "normal"); // Set font to normal
        pdf.setTextColor(0, 0, 0);
        const textWidth = pdf.getTextWidth(element.innerText);
        if (index !== 0) {
          xPosition = xPosition - 1;
        }

        if (xPosition + textWidth > maxWidth) {
          xPosition = 60;
          yPosition += lineHeight;
        }
        // Add two tab spaces if index is 49 for second-row alignment
        // if (index === 80) {
        //   xPosition = xPosition + 60;
        // }

        pdf.text(element.innerText, xPosition, yPosition);
        xPosition += textWidth + 1;
      }
    });

    // ----------------- Message Body Formation ----------------------------------------------------------
    document.getElementById("outputBody").innerHTML = splitString(
      messageConversation?.Body
    );

    const outputBody = document.getElementById("outputBody");
    //  output = splitString(messageConversation?.MessageSubject);
    const elementsBody = outputBody.querySelectorAll(".emoji, .text");

    let xPositionBody = 94;
    let yPositionBody = currentY + 35;
    const maxWidthBody = pdf.internal.pageSize.width - 20;
    const lineHeightBody = 4;

    elementsBody.forEach((element, index) => {
      if (element.classList.contains("emoji")) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // canvas.width = 30;
        // canvas.height = 30;
        if (isFamilyEmoji(element.innerText)) {
          canvas.width = 40;
          canvas.height = 40;
        } else if (isFamilyEmojiFour(element.innerText)) {
          canvas.width = 40;
          canvas.height = 40;
        } else {
          canvas.width = 35;
          canvas.height = 35;
        }
        ctx.font = "13px  Calibri, sans-serif";
        ctx.fillText(element.innerText, 0, 18);

        const imgData = canvas.toDataURL("image/png");

        if (xPositionBody + 6 > maxWidthBody) {
          xPositionBody = 47;
          yPositionBody += lineHeightBody;
        }

        if (isFamilyEmojiFour(element.innerText))
          pdf.addImage(
            imgData,
            "PNG",
            xPositionBody + 1,
            yPositionBody - 5,
            8,
            10
          );
        else if (isFamilyEmoji(element.innerText))
          pdf.addImage(
            imgData,
            "PNG",
            xPositionBody,
            yPositionBody - 5,
            10,
            10
          );
        else
          pdf.addImage(imgData, "PNG", xPositionBody - 1, yPositionBody - 5, 10, 10);

        //  pdf.addImage(imgData, 'PNG', xPositionBody, yPositionBody - 5, 8, 8);
        xPositionBody += 6;
      } else {
        pdf.setTextColor(0, 0, 0);
        const textWidth = pdf.getTextWidth(element.innerText);
        if (index !== 0) {
          xPositionBody = xPositionBody - 1;
        }
        if (xPositionBody + textWidth > maxWidthBody) {
          xPositionBody = 47;
          yPositionBody += lineHeightBody;
        }
        // Add two tab spaces if index is 49 for second-row alignment
        // if (index === 80) {
        //   // xPosition += pdf.getTextWidth("                                                   "); // Approximate width of two tab spaces
        //   xPositionBody = xPositionBody + 5;
        // }

        pdf.text(element.innerText, xPositionBody, yPositionBody);
        xPositionBody += textWidth + 1;
      }
    });

    //   ------------ Emoji End -------------------------------------------------------------

    currentY = pdf.lastAutoTable.finalY + 10; // Update Y position for the next record
    recordCount++; // Increment record count
  });

  const totalPages = pdf.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i);
    addWatermark(pdf, pageWidth, pageHeight); // Add watermark
    addPageNumbers(pdf, i, totalPages, pageWidth, pageHeight); // Add page numbers
  }

  pdf.save(`${title || "MessageConversation"}.pdf`);
};

// Helper to add watermark
const addWatermark = (pdf, pageWidth, pageHeight) => {
  pdf.saveGraphicsState();
  pdf.setGState(new pdf.GState({ opacity: 0.1 }));
  pdf.setFontSize(122);
  pdf.setFont("times", "normal");
  pdf.setTextColor(180, 180, 180);
  pdf.text("Inmate Inbox", pageWidth / 2, pageHeight / 2, {
    align: "center",
    angle: 45,
  });
  pdf.restoreGraphicsState();
};

// Helper to add page numbers
const addPageNumbers = (pdf, pageNumber, totalPages, pageWidth, pageHeight) => {
  pdf.setFontSize(8);
  pdf.text(
    `Page ${pageNumber} of ${totalPages}`,
    pageWidth - 20,
    pageHeight - 10,
    { align: "right" }
  );
};

export default generateMessageConversationPDF;
